import {
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  useTheme,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { AtticusForm } from "../../../models/AtticusForm";
import circleThumbnailBackdrop from "./../../assets/circle-thumbnail-backdrop-1x.png";
import { LARAVEL_APP_HOST } from "../../../constants";
import { FormThumbnail } from "../FormThumbnail";

interface Props {
  open: boolean;
  onClose: () => void;
  form?: AtticusForm;
}

export default function AtticusFormUpgradeToViewDialog({
  open,
  onClose,
  form,
}: Props): JSX.Element {
  if (!open) {
    return <></>;
  }
  const theme = useTheme();
  const isMobileSize = useMediaQuery(theme.breakpoints.down("sm"));
 
  // when sending users to payment screen, we want them be redirected back to /app/forms-and-files when complete
  const redirectToAfterUpgrade = encodeURIComponent(
    window.location.protocol +
      "//" +
      window.location.host +
      // "/app/forms-and-files"
      "/app/forms-and-files"
  );
  
  return (
    <Dialog
      fullScreen={isMobileSize}
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          padding: 5,
        },
      }}
    >
      {open && form ? (
        <>
          
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Box
                sx={{
                  position: "relative",
                }}
              >
                {circleThumbnailBackdrop && <Box
                  component="img"
                  sx={{
                    height: 160,
                    width: 160,
                    objectFit: "contain",
                  }}
                  src={circleThumbnailBackdrop}
                />}
                <FormThumbnail form={form} sx={{
                    height: 120,
                    width: 92,
                    objectFit: "contain",
                    position: "absolute",
                    top: 160 / 2 - 120 / 2,
                    left: 160 / 2 - 92 / 2,
                  }} 
                  onClick={null} />
              </Box>
            </Box>
          </>
        
          <DialogTitle id="responsive-dialog-title" component="div">
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  maxWidth: 600,
                  alignSelf: "center",
                  textAlign: "center",
                }}
              >
                Upgrade to a paid plan to access this premium feature
              </Typography>

              <Box
                sx={{
                  marginTop: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  sx={{
                    borderRadius: 2,
                    width: "fit-content",
                  }}
                  onClick={() => {
                    window.location.href = `${LARAVEL_APP_HOST}/payment-plan?redirectToAfterUpgrade=${redirectToAfterUpgrade}`;
                  }}
                >
                  Explore plans
                </Button>
                <Button
                  variant="text"
                  sx={{
                    color: "#00000099",
                    width: "fit-content",
                    marginTop: 4,
                  }}
                  onClick={() => onClose()}
                >
                  No thanks, continue without a plan
                </Button>
              </Box>
            </Box>
          </DialogTitle>
        </>
      ) : (
        <DialogContent
          sx={{
            textAlign: "center",
          }}
        >
          No form selected
        </DialogContent>
      )}
    </Dialog>
  );
}
